"use client";
import { Award, BarChart3, LineChart } from "lucide-react";
import {
  LiquidPill,
  LiquidPillGroup,
  type LiquidPillGroupItem,
} from "components/ui/v2";
import { PageShell } from "components/ui/v2/layout/page-shell";
import { PageToolbarV2 } from "components/ui/v2/maintainer/page-toolbar-v2";
import useTranslation from "next-translate/useTranslation";
import { useMemo, useState } from "react";
import { DashboardCertificationsPanelV2 } from "./DashboardCertificationsPanelV2";
import { DashboardSeniorityPanelV2 } from "./DashboardSeniorityPanelV2";

export function DashboardPageV2() {
  const { t } = useTranslation("common");
  const [active, setActive] = useState<string>("certifications");
  const tabItems = useMemo(
    (): LiquidPillGroupItem[] => [
      {
        value: "certifications",
        label: t("Certificaciones"),
        icon: <Award className="h-3.5 w-3.5" />,
        variant: "indigo",
      },
      {
        value: "seniority",
        label: t("Seniority"),
        icon: <BarChart3 className="h-3.5 w-3.5" />,
        variant: "indigo",
      },
    ],
    [t]
  );

  const activeTabLabel =
    active === "seniority" ? t("Seniority") : t("Certificaciones");

  return (
    <PageShell
      header={{
        title: t("Certificaciones y Seniority"),
        description: t(
          "Estadísticas de tu organización acerca de certificaciones y seniority"
        ),
        leadingIcon: (
          <LineChart className="h-10 w-10 shrink-0 text-indigo-600 dark:text-indigo-300" />
        ),
        particleIcon: LineChart,
        badges: (
          <>
            <LiquidPill
              variant="indigo"
              appearance="tinted"
              size="sm"
              icon={<LineChart className="h-4 w-4" />}
              text={t("Dashboard")}
            />
            <LiquidPill
              variant="indigo"
              appearance="tinted"
              size="sm"
              icon={
                active === "seniority" ? (
                  <BarChart3 className="h-4 w-4" />
                ) : (
                  <Award className="h-4 w-4" />
                )
              }
              text={activeTabLabel}
            />
            <LiquidPill
              variant="indigo"
              appearance="tinted"
              size="sm"
              icon={<BarChart3 className="h-4 w-4" />}
              text={t("Organización")}
            />
          </>
        ),
      }}
      toolbar={
        <PageToolbarV2
          leftSlot={
            <LiquidPillGroup
              items={tabItems}
              activeValue={active}
              onChange={setActive}
              size="sm"
            />
          }
        />
      }
    >
      {active === "certifications" && <DashboardCertificationsPanelV2 />}
      {active === "seniority" && <DashboardSeniorityPanelV2 />}
    </PageShell>
  );
}
